const OVERLAY_ID = 'bp-cart-overlay';
const CART_SELECTORS = ['.cart-drawer__dialog', '.cart-page'];

function buildOverlay() {
  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.className = 'bp-cart-overlay';
  overlay.setAttribute('role', 'status');
  overlay.setAttribute('aria-label', 'Calculating ship dates');
  overlay.innerHTML = `
    <div class="bp-cart-overlay__modal">
      <div class="bp-cart-overlay__bars">
        <span></span><span></span><span></span>
      </div>
      <p class="bp-cart-overlay__label">Calculating ship dates</p>
    </div>
  `;
  return overlay;
}

function bpToggleCartOverlay(isActive) {
  if (isActive) {
    CART_SELECTORS.forEach((selector) => {
      const container = document.querySelector(selector);
      if (!container || container.querySelector(`#${OVERLAY_ID}`)) return;
      container.appendChild(buildOverlay());
    });
  } else {
    document.querySelectorAll(`#${OVERLAY_ID}`).forEach((el) => el.remove());
  }
}

window.bpToggleCartOverlay = bpToggleCartOverlay;
